import {
  createAction,
  ActionFunction1,
  ActionMeta,
  Action,
} from "redux-actions";
import {
  HotelSchema,
  HotelsSchema,
  HotelsForMapSchema,
} from "main/javascripts/schemas/HotelSchema";
import * as Hotel from "main/javascripts/models/Hotel";
import {
  INIT_HOTEL,
  INIT_HOTELS,
  SET_HOTEL_ROOMS,
  SET_HOTEL_IMAGE,
  POLLING_HOTELS_SUCCESS,
  POLLING_HOTELS_REQUEST,
  POLLING_HOTELS_FAILURE,
  SET_IS_HOTEL_SHOW_MAP_VIEW,
  POLLING_HOTELS_FOR_MAP_REQUEST,
  POLLING_HOTELS_FOR_MAP_FAILURE,
  POLLING_HOTELS_FOR_MAP_SUCCESS,
  SET_HOTEL_MAP_COORDINATES,
  SET_DISPLAY_HOTEL_SEARCH_FORM,
  SET_DISPLAY_HOTEL_IMAGE_MODAL,
  SET_DISPLAY_HOTEL_ROOM_IMAGE_MODAL,
  SET_HOTEL_ROOM_MODAL_IMAGES,
  SET_HOTEL_ROOM_MODAL_DETAILS,
  SET_DISPLAY_HOTEL_ROOM_DETAIL_MODAL,
  SET_IS_LOADING_ROOM,
  SET_REQUEST_ROOM_ERROR,
} from "main/javascripts/constants/actionType/HotelActionType";
import { Img } from "main/javascripts/models/Img";
import { HotelRoom } from "main/javascripts/models/HotelRoom";

interface IInitHotelMeta {
  schema: typeof HotelSchema;
}

export const initHotel: ActionFunction1<
  Hotel.IDetail,
  ActionMeta<Hotel.IDetail, IInitHotelMeta>
> = createAction<Hotel.IDetail, IInitHotelMeta, Hotel.IDetail>(
  INIT_HOTEL,
  (hotel: Hotel.IDetail): Hotel.IDetail => {
    return hotel;
  },
  (): IInitHotelMeta => {
    return {
      schema: HotelSchema,
    };
  }
);

interface IInitHotelsMeta {
  schema: typeof HotelsSchema;
}
interface IInitHotelsPayload {
  hotels: Hotel.IList[];
  page: number;
  numPerPage: number;
  totalNum: number;
}

export const initHotels: ActionFunction1<
  IInitHotelsPayload,
  ActionMeta<IInitHotelsPayload, IInitHotelsMeta>
> = createAction<IInitHotelsPayload, IInitHotelsMeta, IInitHotelsPayload>(
  INIT_HOTELS,
  (param: IInitHotelsPayload): IInitHotelsPayload => {
    return param;
  },
  (): IInitHotelsMeta => {
    return {
      schema: HotelsSchema,
    };
  }
);

type ISetHotelRooms = {
  [index: number]: any;
};
export const setHotelRooms: ActionFunction1<
  ISetHotelRooms,
  Action<ISetHotelRooms>
> = createAction<ISetHotelRooms, ISetHotelRooms>(
  SET_HOTEL_ROOMS,
  (param: ISetHotelRooms): ISetHotelRooms => {
    return param;
  }
);

type ISetHotelImage = {
  [url: string]: any;
};

export const setHotelImage: ActionFunction1<
  ISetHotelImage,
  Action<ISetHotelImage>
> = createAction<ISetHotelImage, ISetHotelImage>(
  SET_HOTEL_IMAGE,
  (image: ISetHotelImage): ISetHotelImage => {
    return image;
  }
);

export const pollingHotelsRequest: any = createAction(POLLING_HOTELS_REQUEST);
export const pollingHotelsFailure: any = createAction(POLLING_HOTELS_FAILURE);
interface IPollingHotelsSuccessMeta {
  schema: typeof HotelsSchema;
}
interface IPollingHotelsSuccessPayload {
  hotels: Hotel.IList[];
  isPolling: number;
  page: number;
}

export const pollingHotelsSuccess: ActionFunction1<
  IPollingHotelsSuccessPayload,
  ActionMeta<IPollingHotelsSuccessPayload, IPollingHotelsSuccessMeta>
> = createAction<
  IPollingHotelsSuccessPayload,
  IPollingHotelsSuccessMeta,
  IPollingHotelsSuccessPayload
>(
  POLLING_HOTELS_SUCCESS,
  (param: IPollingHotelsSuccessPayload): IPollingHotelsSuccessPayload => {
    return param;
  },
  (): IPollingHotelsSuccessMeta => {
    return {
      schema: HotelsSchema,
    };
  }
);

export const setIsHotelMapView: ActionFunction1<
  boolean,
  Action<boolean>
> = createAction<boolean, boolean>(
  SET_IS_HOTEL_SHOW_MAP_VIEW,
  (showMapView: boolean): boolean => {
    return showMapView;
  }
);

interface IPollingHotelsForMapSuccessMeta {
  schema: typeof HotelsForMapSchema;
}
export const pollingHotelsForMapRequest: any = createAction(
  POLLING_HOTELS_FOR_MAP_REQUEST
);
export const pollingHotelsForMapFailure: any = createAction(
  POLLING_HOTELS_FOR_MAP_FAILURE
);
export const pollingHotelsForMapSuccess: ActionFunction1<
  IPollingHotelsSuccessPayload,
  ActionMeta<IPollingHotelsSuccessPayload, IPollingHotelsForMapSuccessMeta>
> = createAction<
  IPollingHotelsSuccessPayload,
  IPollingHotelsForMapSuccessMeta,
  IPollingHotelsSuccessPayload
>(
  POLLING_HOTELS_FOR_MAP_SUCCESS,
  (param: IPollingHotelsSuccessPayload): IPollingHotelsSuccessPayload => {
    return param;
  },
  (): IPollingHotelsForMapSuccessMeta => {
    return {
      schema: HotelsForMapSchema,
    };
  }
);

export const setHotelMapCoordinates: ActionFunction1<
  boolean,
  Action<boolean>
> = createAction<boolean, boolean>(
  SET_HOTEL_MAP_COORDINATES,
  (centerCoordinates: any): boolean => {
    return centerCoordinates;
  }
);

interface ISetDisplayHotelSearchFormPayload {
  isDisplayedSearchForm: boolean;
}
export const setDisplayHotelSearchForm: ActionFunction1<
  ISetDisplayHotelSearchFormPayload,
  Action<ISetDisplayHotelSearchFormPayload>
> = createAction<
  ISetDisplayHotelSearchFormPayload,
  ISetDisplayHotelSearchFormPayload
>(
  SET_DISPLAY_HOTEL_SEARCH_FORM,
  (
    param: ISetDisplayHotelSearchFormPayload
  ): ISetDisplayHotelSearchFormPayload => {
    return param;
  }
);

export const setDisplayHotelImageModal: ActionFunction1<
  boolean,
  Action<boolean>
> = createAction<boolean, boolean>(
  SET_DISPLAY_HOTEL_IMAGE_MODAL,
  (isDisplayed: boolean): boolean => {
    return isDisplayed;
  }
);

export const setDisplayHotelRoomImageModal: ActionFunction1<
  boolean,
  Action<boolean>
> = createAction<boolean, boolean>(
  SET_DISPLAY_HOTEL_ROOM_IMAGE_MODAL,
  (isDisplayed: boolean): boolean => {
    return isDisplayed;
  }
);

export const setHotelRoomModalImages: ActionFunction1<
  Img[],
  Action<Img[]>
> = createAction<Img[], Img[]>(
  SET_HOTEL_ROOM_MODAL_IMAGES,
  (images: Img[]): Img[] => {
    return images;
  }
);

export const setDisplayHotelRoomDetailModal: ActionFunction1<
  boolean,
  Action<boolean>
> = createAction<boolean, boolean>(
  SET_DISPLAY_HOTEL_ROOM_DETAIL_MODAL,
  (isDisplayed: boolean): boolean => {
    return isDisplayed;
  }
);

type ISetHotelRoomModalDetails = {
  hotelId: number;
  hotelRoom: HotelRoom;
  onSelectHotelPlan?: any;
};

export const setHotelRoomModalDetails: ActionFunction1<
  ISetHotelRoomModalDetails,
  Action<ISetHotelRoomModalDetails>
> = createAction<ISetHotelRoomModalDetails, ISetHotelRoomModalDetails>(
  SET_HOTEL_ROOM_MODAL_DETAILS,
  (param: ISetHotelRoomModalDetails): ISetHotelRoomModalDetails => {
    return param;
  }
);

export const setIsLoadingRoom: ActionFunction1<
  boolean,
  Action<boolean>
> = createAction<boolean, boolean>(
  SET_IS_LOADING_ROOM,
  (isLoadingRoom: boolean): boolean => {
    return isLoadingRoom;
  }
);

export const setRequestRoomError: ActionFunction1<
  boolean,
  Action<boolean>
> = createAction<any, any>(SET_REQUEST_ROOM_ERROR, (error: any): any => {
  return error;
});
